// extracted by mini-css-extract-plugin
module.exports = {"input":"simpleInput_input__s4QJ4","error":"simpleInput_error__77Yba","visible":"simpleInput_visible__BtKG0"};